import React from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import './styles.css';

export default function Factor({ factors, title }) {
  return (
    <div className="application-factors-factor">
      <h3>{title}</h3>
      <section>
        {sortBy(factors, ['type']).map(f => (
          <p key={f.type}>{f.type}</p>
        ))}
      </section>
    </div>
  );
}

Factor.prototype = {
  factors: PropTypes.array,
  title: PropTypes.string,
};
